<div class="w3-sidebar w3-bar-block w3-animate-left sidebar-transition" style="width: 55%; right: 0px;" id="candidate_slider">

  <div class="d-flex justify-content-between">
    <div class="mt-3 w-100">
      <div class="row mb-3 justify-content-between d-flex">
        <div class="canProfilePic position-relative ml-4">
          <i class="fas fa-user text-dis" *ngIf="!basicdetails?.candidateimage"></i>
          <img src="{{basicdetails?.candidateimage}}" class="img-fluid" alt="None" *ngIf="basicdetails?.candidateimage">
        </div>
        <!-- Candidate Profile Header -->
        <div class="col text-capitalize d-flex justify-content-between">
          <div class="">
            <p class="font-weight-600 f-14 mb-1">{{basicdetails?.firstname}} {{basicdetails?.lastname}}
              <span *ngIf="basicdetails?.is_unsubscribed" matTooltip="Unsubscribed from Email Campaign" [matTooltipClass]="{ 'red-tooltip text-black': true }" class="px-1 ml-1" style="color: #e54f7a; background-color: #fff5f8; border-radius: 100px;">
                <i class="fa-solid fa-envelopes-bulk f-12"></i>
            </span>
            </p>
            <p class="f-14 mb-1 "><span class="line-clamp"
                matTooltip="{{basicdetails?.jobtitle | titlecase}} at {{basicdetails?.companyname | titlecase}}"
                [matTooltipClass]="{ 'red-tooltip': true }"> {{basicdetails?.jobtitle}}
                <span *ngIf="basicdetails?.companyname"> at </span>{{basicdetails?.companyname}}</span></p>
            <div class="d-flex">
              <div class="f-12 mb-1 text-9696 d-flex align-items-center"><i class="far fa-map-marker-alt mr-1"
                  *ngIf="basicdetails?.locationname"></i> {{basicdetails?.locationname}} <i
                  class="fa-solid fa-circle mx-2" style="font-size: 4px;"
                  *ngIf="basicdetails?.totalexperience && basicdetails?.locationname"></i>
                <i class="fa-regular fa-briefcase mr-1" *ngIf="basicdetails?.totalexperience"></i><span>
                  {{getFormattedTenure(basicdetails?.totalexperience)}}</span> <i class="fa-solid fa-circle mx-1"
                  *ngIf="(basicdetails?.locationname || basicdetails?.totalexperience) && (linkedin_url?.link || twitter_url || facebook_url || github_url)"
                  style="font-size: 5px;"></i>
                <div class="mr-3 pointer" *ngIf="linkedin_url?.link" title="{{linkedin_url?.platformname}}">
                  <a data-testid="auto-app-email-campaign-candidate-slider-a-1" class="f-14 text-black" (click)="openUrl(linkedin_url?.link, 'linkedin')"
                    [ngClass]="{'p-none' : linkedin_url?.link.includes('****')}">
                    <i class="fa fa-linkedin-square" style="color: #0652ba;"
                      [ngClass]="{'text-9696' : linkedin_url?.link?.includes('****')}"></i></a>
                </div>
                <div class="mr-3" *ngIf="twitter_url" title="{{twitter_url?.platformname}}">
                  <a data-testid="auto-app-email-campaign-candidate-slider-a-2" class="f-14 text-black" (click)="openUrl(twitter_url?.link, 'twitter')"
                    [ngClass]="{'p-none' : twitter_url?.link.includes('****')}">
                    <i class="fa-brands fa-square-x-twitter" style="color: #000000;"
                      [ngClass]="{'text-9696' : twitter_url?.link.includes('****')}"></i></a>
                </div>
                <div class="mr-3" *ngIf="facebook_url" title="{{facebook_url?.platformname}}">
                  <a data-testid="auto-app-email-campaign-candidate-slider-a-3" class="f-14 text-black" (click)="openUrl(facebook_url?.link, 'facebook')"
                    [ngClass]="{'p-none' : facebook_url?.link.includes('****')}">
                    <i class="fab fa-facebook" style="color: #1773ea;"
                      [ngClass]="{'text-9696' : facebook_url?.link.includes('****')}"></i></a>
                </div>
                <div class="mr-3" *ngIf="github_url" title="{{github_url?.platformname}}">
                  <a data-testid="auto-app-email-campaign-candidate-slider-a-4" class="f-14 text-black" (click)="openUrl(github_url?.link, 'github')"
                    [ngClass]="{'p-none' : github_url?.link?.includes('****')}">
                    <i class="fab fa-github f-16" style="color: black;"
                      [ngClass]="{'text-9696' : github_url?.link?.includes('****')}"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <div class="row" style="display: flow-root;">
        <div class="col" style="border-bottom: 1px solid #d9d9d9;">

          <ul class="nav nav-pills my-0">
            <li class="nav-item mr-3">
              <a data-testid="auto-app-email-campaign-candidate-slider-a-5" class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" href="#pills-profile" role="tab" (click)="onTabChange('details')"
                #detailsslider [ngClass]="{'active': tabtoShow == 'details'}" aria-controls="pills-profile"
                aria-selected="true">Profile</a>
            </li>
            <li class="nav-item mr-3" *ngIf="canEditCampaign">
              <a data-testid="auto-app-email-campaign-candidate-slider-a-6" class="nav-link" id="pills-contact-tab" data-bs-toggle="pill" href="#pills-contact" role="tab" (click)="onTabChange('contactTab')"
                #detailsslider [ngClass]="{'active': tabtoShow == 'contactTab'}" aria-controls="pills-contact"
                aria-selected="true">Contact</a>
            </li>
            <li class="nav-item">
              <a data-testid="auto-app-email-campaign-candidate-slider-a-7" class="nav-link" id="pills-activities-tab" data-bs-toggle="pill" href="#pills-activities" role="tab" (click)="onTabChange('activity')"
                aria-controls="pills-activities" aria-selected="false" [ngClass]="{'active': tabtoShow == 'activity'}">Campaign Activity</a>
            </li>
          </ul>
        </div>
        <hr class="mt-0 mb-3">
      </div>


      <div class="tab-content" id="pills-tabContent">
        <div *ngIf="(tabtoShow == 'details')" class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab"
          [ngClass]="{'show active': tabtoShow == 'details'}">
          <div>

            <!-- Skill -->
            <div class="row mb-3">
              <div class="col">
                <p class="f-14 font-weight-600 mb-3 d-flex justify-content-between"> <span> <i
                      class="fa-regular fa-book-open f-12 font-weight-normal mr-2"></i>Skills</span> </p>
                <p class="f-14 mb-1"><span class="label-new" *ngFor="let skill of skillsdata">{{skill}}</span> </p>
                <p class="mb-1 f-14 text-dis"
                  *ngIf='additionaldetails?.information.length == null || additionaldetails?.information.length == 0'>
                  Not Available</p>
                </div>
              </div>
            </div>
            <hr class="mt-0 mb-1">

            <!-- Headline -->
            <div class="row mb-3" *ngIf="basicdetails?.headline">
              <div class="col">
                <p class="f-14 font-weight-600 mb-3 d-flex justify-content-between"> <span>
                    <i class="fa-light fa-circle-user f-12 font-weight-normal mr-2"></i>Headline</span> </p>
                <p class="f-14 mb-1">{{basicdetails.headline}} </p>
              </div>
            </div>
            <hr  *ngIf="basicdetails?.headline" class="mt-0 mb-1">
            

          <!-- Experience details -->
          <!-- (basicdetails?.pdldetailsextracted == 0)  -->
          <div *ngIf="(experiencedetails?.length > 0 || educationdetails?.length > 0)">
            <div class="row">
              <div class="col d-flex justify-content-between">
                <span class="f-14 font-weight-600"> <i class="fa-regular fa-briefcase f-12 font-weight-normal mr-2"></i>
                  Experience</span>
                <!-- <span *ngIf="isCurrentUserTheCreator" class="pointer text-bluex ats-cta-btn">
                  <i class="fa-regular fa-plus webtree-btn" (click)="EditExperienceDetails()"></i></span> -->
              </div>
            </div>
            <div class="" *ngIf="experiencedetails?.length > 0">
              <div class="row mb-3px onHover py-1 position-relative" *ngFor="let experience of experiencedetails">
                <div class="col">
                  <!-- <div> -->
                  <div class="d-flex mb-1">
                    <div>
                      <span class="clogo">
                        <i class="fas fa-building" *ngIf="!experience?.companylogo"></i>
                        <img [src]="experience?.companylogo" class="img-fluid" *ngIf="experience?.companylogo"
                          [alt]="experience?.companyname">
                      </span>
                    </div>
                    <div class="onHover d-flex justify-content-between w-100">
                      <div>
                        <p class="f-12 font-weight-500 mb-1">{{experience?.jobtitle | titlecase}}</p>
                        <p class="f-12 mb-1"  (mouseenter)="getCompanyInfo(experience)" [ngClass]="{'companyHover': experience?.website, 'dstooltip pointer':experience?.website}">{{experience?.companyname  | titlecase}}

                        <span class="dstooltip-content" *ngIf="companyInfoCalled">
                              <app-company-hover-modal [companyInformation]="currentCompanyInformation"></app-company-hover-modal>
                            </span>
                        </p>


                        <p class="f-12 mb-1 text-9696 d-flex align-items-center">
                          <span>{{experience?.locationname}}</span> <i class="fas fa-circle f-10 mx-2"
                          style="font-size:3px; margin-top: 0px;" *ngIf="experience?.locationname"></i> <span
                          class="f-12 gray-text"
                          *ngIf="experience.iscurrent == 0 && experience?.startdate != 'Invalid date' && experience?.enddate != 'Invalid date'">
                          {{experience?.startdate | date: 'MMM yyyy'}} <span
                          *ngIf="experience?.startdate && experience?.enddate">-</span> {{experience?.enddate |
                            date: 'MMM yyyy'}}</span>
                            <span class="f-12 gray-text"
                            *ngIf="experience.iscurrent == 1 && experience?.startdate != null">
                            {{experience?.startdate | date: 'MMM yyyy'}} -
                            Current</span>
                          </p>
                          <p class="f-12" *ngIf="experience?.workdescription?.length">
                            <span *ngIf="experience?.formattedWorkDescription?.data?.length <= 1">
                              <span>
                                {{experience?.formattedWorkDescription.data[0]}}
                              </span>
                            </span>

                            <span *ngIf="experience?.formattedWorkDescription?.data?.length > 1" class="exp-list">
                              <ul>
                                <li *ngFor="let exp of experience?.formattedWorkDescription.data">
                                  {{exp}}
                                </li>
                              </ul>
                            </span>

                            <span class="f-12 pointer text-webbtree-green"
                              *ngIf="experience?.formattedWorkDescription?.canOverflow && experience?.formattedWorkDescription?.isTruncated"
                              (click)="formatDescription('view-more', experience)">
                              view more
                            </span>
                            <span class="f-12 pointer text-webbtree-green"
                              *ngIf="experience?.formattedWorkDescription?.canOverflow && !experience?.formattedWorkDescription?.isTruncated"
                              (click)="formatDescription('view-less', experience)">
                              view less
                            </span>
                          </p>
                      </div>
                    </div>
                  </div>
                  <hr style="color: #d5dee6; width: 100%; text-align: center; height: 1px; margin: 0;" *ngIf="i != experiencedetails.length - 1">
                </div>
              </div>

            </div>
          </div>
          <div class="row" *ngIf="experiencedetails?.length == 0">
            <div class="col">
              <p class="f-14 text-dis mb-0"> Not Available</p>
            </div>
          </div>
          <!-- <hr style="color: #d5dee6; width: 100%; text-align: center; height: 1px; margin: 0;" *ngIf="i != experiencedetails.length - 1"> -->

          <!-- Education details -->
          <div class="row">
            <div class="col d-flex justify-content-between">
              <span class="f-14 font-weight-600"><i
                  class="fa-regular fa-user-graduate f-12 font-weight-normal mr-2"></i> Education </span>
            </div>
          </div>
          <div class="" *ngIf="educationdetails?.length > 0">
            <div class="row mb-3px onHover py-1 position-relative" *ngFor="let education of educationdetails; let i = index">
              <div class="col d-flex w-100">

                <div class="clogo mr-3">
                  <i class="fas fa-graduation-cap f-12"></i>
                </div>
                <div>
                  <p class="f-14 mb-1"> {{education?.degree | titlecase}} <span
                      *ngIf="education?.fieldofstudy && education?.degree">in </span>
                    {{education?.fieldofstudy | titlecase}} </p>
                  <p class="text-9696 f-12 d-flex align-items-center mb-1 mr-1">{{education?.institutename | titlecase}}
                    <!-- <i class="fas fa-circle f-10 mx-1" style="font-size:3px; margin-top: 0px;" aria-hidden="true"></i> -->
                    <span
                      *ngIf="education?.startdate != 'Invalid date' && education?.enddate != 'Invalid date'">{{education?.startdate}}
                      - {{education?.enddate}}</span>
                  </p>
                </div>
              </div>
              <hr style="color: #d5dee6; width: 100%; text-align: center; height: 1px; margin: 0; margin-left: 20px;" *ngIf="(i != educationdetails.length - 1)">
            </div>
          </div>
          <div class="row mb-2" *ngIf="educationdetails?.length == 0">
            <div class="col">
              <p class="mb-1 f-14 text-dis"> Not Available</p>

            </div>
          </div>
          
          <!-- Candidate Certificates -->
          <div *ngIf="certificationDetails?.length">
            <hr class="mt-0 mb-3">
            <div class="row">
              <div class="col d-flex justify-content-between">
                <span class="f-14 font-weight-600">
                  <i class="far fa-file-certificate f-12 font-weight-normal mr-2"></i>
                  Certification
                </span>
              </div>
            </div>
            <div>
              <div class="row mb-3px onHover py-1 position-relative" *ngFor="let cert of certificationDetails; let i = index">
                <div class="col d-flex w-100">
          
                  <div class="clogo mr-3">
                    <i class="fa-duotone fa-solid fa-certificate"></i>
                  </div>
                  <div>
                    <p class="f-14 mb-1" *ngIf="cert?.name"> {{cert?.name | titlecase}}
                    <p class="text-9696 f-12 d-flex align-items-center mb-1 mr-1">
                      {{cert?.organization | titlecase}}
                      <i class="fas fa-circle f-10 mx-2" style="font-size:3px; margin-top: 0px;" *ngIf="cert?.organization && (cert?.startdate || cert?.enddate )"></i>
                      <span *ngIf="cert?.startdate != 'Invalid date' && cert?.enddate != 'Invalid date'">{{cert?.startdate | date: 'MMM yyyy'}}
                        <span *ngIf="cert?.startdate && cert?.enddate">-</span> 
                        {{cert?.enddate |  date: 'MMM yyyy'}}</span>
                    </p>
                  </div>
                </div>
                <hr style="color: #d5dee6; width: 100%; text-align: center; height: 1px; margin: 0; margin-left: 20px;"
                  *ngIf="(i != cert.length - 1)">
              </div>
            </div>
          </div>
        </div>

        <div class="tab-pane fade" id="pills-activities" role="tabpanel" aria-labelledby="pills-activities-tab" [ngClass]="{'show active': tabtoShow == 'activity'}" >
          <div class="card bt" *ngFor="let campTarget of campaignsOfTarget; let i = index">
            <div class="card-header" id="heading{{i}}" (click)="getEmailDetails(campTarget?.campaign_id,campTargetID)">
              <h5 class="mb-0">
                <button data-testid="auto-app-email-campaign-candidate-slider-button-1" class="btn btn-link px-0 collapsed f-14 w-100 text-left" type="button" data-bs-toggle="collapse"
                  [attr.data-bs-target]="'#collapse' + i" aria-expanded="false" [attr.aria-controls]="'collapse' + i">
                  <span class="position-relative font-weight-500"> {{campTarget?.campaign_name}}
               </span>
                  <span class="wcAccordianUpDownArrow text-webbtree-green">
                    <span class="test1"><i class="far fa-angle-up f-14 font-weight-500"></i></span>
                    <span class="test2"> <i class="far fa-angle-down font-weight-500 f-14"></i></span>
                  </span>
                </button>
              </h5>
            </div>
            <div id="collapse{{i}}" class="collapse" [ngClass]="{show: i===0}" [attr.aria-labelledby]="'heading' + i">
                <div *ngFor="let email of emailData; let j = index">
                  <div class="position-relative mb-3">
                    <div class="d-flex justify-content-between py-2 font-weight-500">
                      <span>step {{j+1}} {{email?.stage_name}}</span>
                      <span> <i class="fa-regular fa-calendar mr-1"></i> {{getFormattedDate(email?.sent_on)}}</span>
                    </div>
                    <div class="email-block">
                      <div>
                        <p><span style="margin-right: 28px;">From:</span> {{ email.from}} </p>
                        <p> <span class="mr-3"> Subject:</span>{{email?.subject}}</p>
                      </div>
                      <hr class="mt-0 mb-3">
                      <div [innerHTML]="email?.body">
                      </div>
                      <div *ngIf="email.attachments?.length > 0" style="background-color: #f6f6f6;">
                        <app-attachment-list [files]="email.attachments" mode="view">
                        </app-attachment-list>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="hasReplied && email.has_reply" class="position-relative mb-3 email-block" style="background-color: #eaf4f6; margin-top: -15px;">
                    <div class="d-flex justify-content-between py-2 font-weight-600">
                      <span>Replied by {{basicdetails?.firstname}}</span>
                      <span> <i class="fa-regular fa-calendar mr-1"></i> {{getFormattedDate(email?.has_reply)}}</span>

                    </div>
                    <hr class="mt-0 mb-3">
                        <div [innerHTML]="repliedData">
                        </div>
                  </div>
                </div>
             </div>
          </div>
        </div>

        <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab"
          [ngClass]="{'show active': tabtoShow == 'contactTab'}">

          <section class="email-contact-slider" *ngIf="tabtoShow === 'contactTab'">
            <app-person-search-contact-slider
              *ngIf="checkIfObjectIsEmpty(candidateDetailObj)"
              [candidateDetails]="candidateDetailObj"
              [addToContactOpen]="addEmailManually"
              [emailCampData] = "dataForPersonSearchContactSlider"
            ></app-person-search-contact-slider>
          </section>
        </div>

      </div>
    </div>

  </div>
</div>

<div class="w3-overlay w3-animate-opacity close-overlay-transition" (click)="candidateSlider_close()"
  id="candidate_Overlay2">
</div>
